import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import { SectionHeader, MainWrapper } from "components"
import { AboutWrapper, AboutContent } from "./styles"

export const About = () => {
  return (
    <AboutWrapper id="about">
      <MainWrapper>
        <SectionHeader title="About Us" />
        <AboutContent>
          <div className="left">
            <h1 data-sal="slide-up" data-sal-delay="300" data-sal-easing="ease">
              Welcome to Neighbarista.
            </h1>
            {/* <span>by Iman Diaz</span> */}
            <p data-sal="slide-up" data-sal-delay="300" data-sal-easing="ease">
              We are breakfast elevated in the Santa Clarity Valley. We're
              passionate about making excellent food. We believe that a
              welcoming atmosphere and excellent service pair best with
              excellent food. Everything we serve is made in-house. We have
              unique items like Mexican hot chocolate creamer to go with
              Intelligentsia Coffee. We offer a different twist with our
              Horchata French Toast. We are known for memorable pancakes that
              are perfectly crispy on the outside and pillow-fluffy on the
              inside. We offer unforgettable pork belly eggs Benedict and one -
              a kind hollandaise sauce. We give great attention to detail to
              everything we do - this is why our guests love their time with us.
              We welcome you to look over our menu, read our reviews and spend
              some time with us, our team, and fall in love with our breakfast
              and lunch dishes.
            </p>

            <div
              data-sal="slide-up"
              data-sal-delay="400"
              data-sal-easing="ease"
            >
              <a
                href="https://www.instagram.com/neighbaristascv/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="25"
                  viewBox="0 0 511 511.9"
                  width="25"
                  fill="var(--primaryColor)"
                >
                  <path d="m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0"></path>
                  <path d="m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0"></path>
                  <path d="m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0"></path>
                </svg>
              </a>
              <a
                href="https://www.facebook.com/neighbaristascv/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="25"
                  viewBox="-21 -21 682.66669 682.66669"
                  width="25"
                  fill="var(--primaryColor)"
                >
                  <path d="m604.671875 0h-569.375c-19.496094.0117188-35.30078125 15.824219-35.296875 35.328125v569.375c.0117188 19.496094 15.824219 35.300781 35.328125 35.296875h306.546875v-247.5h-83.125v-96.875h83.125v-71.292969c0-82.675781 50.472656-127.675781 124.222656-127.675781 35.324219 0 65.679688 2.632812 74.527344 3.808594v86.410156h-50.855469c-40.125 0-47.894531 19.066406-47.894531 47.050781v61.699219h95.9375l-12.5 96.875h-83.4375v247.5h162.796875c19.507813.003906 35.324219-15.804688 35.328125-35.3125 0-.003906 0-.007812 0-.015625v-569.375c-.007812-19.496094-15.824219-35.30078125-35.328125-35.296875zm0 0"></path>
                </svg>
              </a>
            </div>
          </div>
          <div data-sal="slide-up" data-sal-delay="100" data-sal-easing="ease">
            <StaticImage
              imgStyle={{ borderRadius: "20px" }}
              src="../../images/about-photos.jpeg"
              alt="Neighbarista Outdoor Photo"
            />
          </div>
        </AboutContent>
      </MainWrapper>
    </AboutWrapper>
  )
}
